require('../../app.js')

Vue.component('cities-seo-list', require('../../components/CitiesSeoList.vue').default)
Vue.component('districts-seo-list', require('../../components/DistrictsSeoList.vue').default)
Vue.component('estate-card', require('../../components/estates/Card.vue').default)
Vue.component('agencies-advertising', require('../../components/agencies/Advertising.vue').default)
Vue.component('filter-seo-list', require('../../components/FilterSeoList.vue').default)
Vue.component('quarters-seo-list', require('../../components/QuartersSeoList.vue').default)

Vue.component('estates-index', require('./Index.vue').default)
